module.exports = __webpack_public_path__ + "static/media/consignadoExample.eced57a6.jpeg";